const Footer = () => {
  return (
    <footer className="footer">
      <p>
        © 2025 Dr. Gilberto Cascaes Guedes Neto - Desenvolvido por{" "}
        <a href="https://www.flavioebn.com" target="_blank" rel="noreferrer">
          FlavioEBN
        </a>
      </p>
    </footer>
  );
};

export default Footer;
